export const concatTags = (...arrays) => [].concat(...arrays.filter(Array.isArray)).filter((tag) => tag !== '');
